import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_SITE_HANDOVER } from "../../data/constructionServiceImages";

function SiteManagementHandover() {
  return (
    <SectionComponent
      images={IMG_SITE_HANDOVER}
      titles={{
        mainTitle: "Site management & handover",
        subTitle: "Programme control through to completion",
        sectionTitle1: "Site management",
        sectionTitle2: "Quality assurance",
        sectionTitle3: "Completion & handover",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "Daily site leadership covers logistics, health and safety, trade flow, and compliance—so the programme reflects reality on the ground.",
        sectionDescription2: "QA holds align with architect and consultant inspections; we document defects and retesting until standards are met.",
        sectionDescription3: "Handover includes training, as-built records, and structured snagging so the client and design team can sign off with confidence.",
        imageAlt: "Site management and building completion"
      }}
      galleryLink="/projects/shell-core"
      seo={{
        title: "Site management & handover",
        description: "Site management, QA, and handover for construction projects. MA Renovations."
      }}
    />
  )
}

export default SiteManagementHandover;
